import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'mess',
    lazy: async () => ({ Component: (await import('./MessPage')).MessPage }),
  },
];
